











































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import Input from "@/shared/components/ui/Input.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import {
  ExpenseSearchRequest,
  ClaimResultSet,
  FetchState,
  Claim,
  ClaimLine
} from "@/shared/types";
import { useClaimStore } from "@/employee/store/claim";
import { useExpenseStore } from "@/employee/store/expense";


const searchInitialState: ExpenseSearchRequest = {
  startDate: null,
  endDate: null,
  description: ""
};

@Component({
  components: {
    Input,
    Pagination,
    Button,
    GenericLoadingSpinner
  }
})
export default class LinkExpense extends Vue {
  expenseStore = useExpenseStore();
  claimStore = useClaimStore();

  @Prop()
  claimNumber: string;

  formatCurrency = formatCurrency;
  searchModel: ExpenseSearchRequest = { ...searchInitialState };
  comment = "";
  resultExpenses = [];
  isSubmitting = false;

  beforeMount () {
    this.expenseStore.initializeSearchResultState(this.claimNumber);
    this.claimStore.initializeLinkedExpensesState(this.claimNumber);
  }

  mounted () {
    this.cloneToCurrentModel(searchInitialState);
    this.claimStore.loadLinkedExpenses(this.claimNumber).then(() => {
      this.search();
    });
  }

  get displaySearchResults (): boolean {
    return this.expenseStore.searchResultsFetchState(this.claimNumber) === FetchState.Loaded
      && this.expenseStore.searchResults(this.claimNumber).length !== 0;
  }

  get searchResultsLoading (): boolean {
    return this.expenseStore.searchResultsFetchState(this.claimNumber) === FetchState.Loading;
  }

  search () {
    const linkedExpenses = this.claimStore.linkedExpenses(this.claimNumber).map(e => e.expenseId);
    this.expenseStore.setSearchResultPageNumber({ page: 1, claimNumber: this.claimNumber });
    this.expenseStore.searchExpenses({
      pageNumber: this.expenseStore.searchResultsCurrentPage(this.claimNumber),
      pageSize: 5,
      startDate: this.searchModel.startDate,
      endDate: this.searchModel.endDate,
      description: this.searchModel.description,
      claimNumber: this.claimNumber,
      excludedExpenseIds: this.claimStore.linkedExpenses(this.claimNumber).map(e => e.expenseId)
    }).then(() => {
      this.cloneResultToCurrentModel(this.expenseStore.searchResults(this.claimNumber));
    });
  }

  loadPage () {
    const page = this.expenseStore.searchResultsCurrentPage(this.claimNumber);
    this.expenseStore.searchExpenses({
      pageNumber: page,
      pageSize: 5,
      startDate: this.searchModel.startDate,
      endDate: this.searchModel.endDate,
      description: this.searchModel.description,
      claimNumber: this.claimNumber,
      excludedExpenseIds: this.claimStore.linkedExpenses(this.claimNumber).map(e => e.expenseId)
    }).then(() => {
      this.cloneResultToCurrentModel(this.expenseStore.searchResults(this.claimNumber));
    });
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.searchModel = clonedModel;
  }

  cloneResultToCurrentModel (o: Claim[]) {
    o.forEach(c => c.isSelected = false);
    const clonedModel = _.cloneDeep(o);
    this.resultExpenses = clonedModel;
  }

  formattedServiceDate (serviceDate: string): string {
    return moment(serviceDate).format("MMM D, YYYY");
  }

  formattedServiceDateSmall (serviceDate: string): string {
    return moment(serviceDate).calendar();
  }

  onSwitchPage (pageNumber): void {
    this.expenseStore.setSearchResultPageNumber({ page: pageNumber, claimNumber: this.claimNumber });
    this.loadPage();
  }

  get linkExpensesDisabled (): boolean {
    if (this.isSubmitting || this.resultExpenses.filter(c => c.isSelected).length > 0) {
      return false;
    }
    return true;
  }

  get linkExpensesButtonText (): string {
    if (this.resultExpenses.filter(c => c.isSelected).length > 1) {
      return "Link Expenses";
    }
    return "Link Expense";
  }

  toggleExpense (expenseId: number): void {
    const expense = this.resultExpenses.find(c => c.id === expenseId);
    expense.isSelected = !expense.isSelected;
  }

  link (): void {
    this.isSubmitting = true;
    const request = {
      claimNumber: this.claimNumber,
      expenseIds: this.resultExpenses.filter(e => e.isSelected).map(m => m.id),
      comment: this.comment
    };
    this.claimStore.linkExpensesToClaim(request).then(() => {
      this.resultExpenses.forEach(e => e.isSelected = false);
      this.comment = "";
      this.search();
    }).finally(() => {
      this.isSubmitting = false;
    });
  }
}
